<syn-page-loader [class.auth-loading]="loading"
                 [loading]="loading"></syn-page-loader>

<div *ngIf="!loading">
    <div [hidden]="!hasProjects()">
        <syn-message-box-acl [roles]="roles"></syn-message-box-acl>
        <form [formGroup]="dataTableForm" [style.margin-top]="'0.5em'">
            <div fxLayout="row" fxLayoutAlign="space-between center" class="table-actions">
                <div fxLayout="row" fxLayoutAlign="start center">
                    <div fxLayout="row" fxLayoutAlign="start center">
                        <mat-checkbox color="primary"
                                      (change)="$event ? masterToggle() : null"
                                      [checked]="selection.hasValue() && isAllSelected()"
                                      [indeterminate]="selection.hasValue() && !isAllSelected()">
                        </mat-checkbox>
                        <p class="total">{{ total > 0 ? total : '' }}</p>
                    </div>
                    <div class="syn-flexrow__cell--minwidth action-buttons">
                        <button mat-stroked-button
                                class="syn-dropdown-menu"
                                [matMenuTriggerFor]="actionsMenu"
                                [disabled]="actionButtonsDisabled || pending"
                                [matTooltip]="actionButtonsTitle">
                            Actions
                            <mat-icon svgIcon="chevron-down"></mat-icon>
                        </button>
                        <mat-menu #actionsMenu="matMenu"
                                  [overlapTrigger]="false">
                            <button mat-menu-item
                                    (menuOpened)="updateMenuRolesStatus()"
                                    [matMenuTriggerFor]="rolesSubmenu"
                                    [disabled]="roles.length === 0">
                                {{ isInternal ? "Modifier les rôles" : "Sélectionner un rôle" }}
                            </button>
                            <button mat-menu-item
                                    (menuOpened)="updateMenuCommStatus()"
                                    [matMenuTriggerFor]="communicationSubmenu">
                                {{ isInternal ? "Modifier les communications" : "Sélectionner les communications" }}
                            </button>
                        </mat-menu>
                        <mat-menu #rolesSubmenu="matMenu">
                            <syn-menu-checkbox #rolesSubmenuItem
                                               *ngFor="let role of roles"
                                               [label]="role.id"
                                               (click)="updateSelectedUsersRoles($event, rolesSubmenuItem, role)">
                            </syn-menu-checkbox>
                        </mat-menu>
                        <mat-menu #communicationSubmenu="matMenu">
                            <syn-menu-checkbox #communicationSubmenuItem
                                               *ngFor="let comm of preferenceComm"
                                               [label]="comm"
                                (click)="updateSelectedProjectPreferenceCom($event, communicationSubmenuItem, comm)"></syn-menu-checkbox>
                        </mat-menu>
                    </div>
                </div>

                <div fxFlex="1 0 auto">
                    <mat-form-field class="syn--full-width" appearance="outline">
                        <mat-label>Filtrer</mat-label>
                        <input #filter
                               matInput
                               type="text"
                               (keyup)="applyFilter(filter.value)"
                               placeholder="Filtrer" />
                        <button
                                mat-icon-button
                                [disabled]="pending"
                                matSuffix
                                (click)="applyFilter('', filter)">
                            <mat-icon svgIcon="close"></mat-icon>
                        </button>
                    </mat-form-field>
                </div>

                <div fxFlex="1 0 auto">
                    <form [formGroup]="copyFromUserGroup">
                        <syn-picker
                            formControlName='copyFromUser'
                            placeholder="Copier les rôles et communications d'un autre utilisateur."
                            [content]="relatedUsers$"
                            [contentLoader]="relatedUsersContentLoader"
                            [itemTemplate]="relatedUsersTemplate"
                            fxFlexFill>
                            <ng-template #relatedUsersTemplate
                            let-firstName="content.firstName"
                            let-lastName="content.lastName">
                                <div>
                                    {{firstName}} {{lastName}}
                                </div>
                            </ng-template>
                        </syn-picker>
                    </form>
                </div>
            </div>

            <mat-table #table
                       [dataSource]="dataSource"
                       matSort
                       [matSortActive]="sortActive"
                       matSortDirection="asc">

                <!-- actions -->
                <ng-container matColumnDef="select">
                    <mat-header-cell *matHeaderCellDef></mat-header-cell>
                    <mat-cell *matCellDef="let row">
                        <mat-checkbox color="primary"
                                      (click)="$event.stopPropagation()"
                                      (change)="$event ? selection.toggle(row) : null"
                                      [checked]="selection.isSelected(row)">
                        </mat-checkbox>
                    </mat-cell>
                </ng-container>

                <!-- id -->
                <ng-container matColumnDef="projectId">
                    <mat-header-cell *matHeaderCellDef
                                     mat-sort-header>
                        ID
                    </mat-header-cell>
                    <mat-cell *matCellDef="let row">
                        <syn-avatar *ngIf="row.projectId === '*'"
                                    [matIco]="'star'"
                                    [size]="24"></syn-avatar>
                        <syn-project-avatar *ngIf="row.projectId !== '*' && row.project"
                                            [project]="row.project"
                                            [showId]="true"
                                            [size]="24"></syn-project-avatar>
                    </mat-cell>
                </ng-container>

                <!-- name -->
                <ng-container matColumnDef="name">
                    <mat-header-cell *matHeaderCellDef
                                     mat-sort-header>
                        Projet
                    </mat-header-cell>
                    <mat-cell *matCellDef="let row">
                        {{ row.project.name }}&nbsp;
                        <mat-icon
                            *ngIf="row.project.status === 'BUILDING'"
                            matTooltip="Ce projet est en Build : l’utilisateur ne pourra pas créer de ticket Run dessus"
                            class="syn-text--warning" svgIcon="alert-outline">
                        </mat-icon>
                        <mat-icon
                            *ngIf="row.project.status === 'UNPROVISIONED'"
                            matTooltip="Ce projet est en résilié : l’utilisateur ne pourra pas créer de ticket Run dessus"
                            class="syn-text--warning" svgIcon="alert-outline">
                        </mat-icon>
                    </mat-cell>
                </ng-container>

                <!-- roles -->
                <ng-container matColumnDef="roles">
                    <mat-header-cell *matHeaderCellDef
                                    mat-sort-header>
                        Roles
                    </mat-header-cell>
                    <mat-cell *matCellDef="let row">
                        <div class="syn-flexrow mat-column-roles">
                            <div *ngIf="isInternal">
                                <mat-form-field class="syn--full-width"
                                                floatLabel="never"
                                                appearance="outline"
                                                formGroupName="{{row.projectId}}">
                                    <mat-label>Ajouter un rôle</mat-label>
                                    <!-- multi select in edit mode -->
                                    <mat-select #roleSelect
                                                matInput
                                                placeholder="Ajouter un rôle"
                                                [disabled]="pending"
                                                [(value)]="row.roles"
                                                (selectionChange)="updateAuthorization(row.projectId)"
                                                multiple
                                                formControlName="roles">
                                        <mat-select-trigger>
                                            <mat-chip-listbox *ngIf="row.roles?.length">
                                                <mat-chip disableRipple *ngFor="let chip of row.roles">
                                                    {{ chip }}
                                                </mat-chip>
                                            </mat-chip-listbox>
                                        </mat-select-trigger>
                                        <mat-option *ngFor="let role of roles"
                                                    [value]="role.id">
                                            <syn-select-option-role [role]="role"></syn-select-option-role>
                                        </mat-option>
                                    </mat-select>
                                </mat-form-field>
                            </div>

                            <div *ngIf="!isInternal"
                                 formGroupName="{{row.projectId}}">
                                <mat-form-field class="syn--full-width" appearance="outline">
                                    <mat-label>Sélectionner des rôles</mat-label>
                                    <mat-select #roleSelect
                                                [(value)]="row.roles"
                                                placeholder="Sélectionner des rôles" multiple>
                                                <mat-optgroup *ngFor="let app of roleApps" [label]="getAppNameById(app)">
                                                    <mat-option (click)="updateAuthorization(row.projectId, undefined, app)" class="font-italic">
                                                        Aucun rôle
                                                    </mat-option>
                                                    <mat-option *ngFor="let role of rolesDisplayerSelectSortedByApp[app]"
                                                        [value]="role.id"
                                                        (click)="updateAuthorization(row.projectId, role.id, app)">
                                                        <syn-select-option-role [role]="role"></syn-select-option-role>
                                                    </mat-option>
                                                </mat-optgroup>
                                    </mat-select>
                                </mat-form-field>
                            </div>

                        </div>
                    </mat-cell>
                </ng-container>

                <!-- MSO -->
                <ng-container matColumnDef="mso">
                    <mat-header-cell *matHeaderCellDef
                                     mat-sort-header
                                     matTooltip="Envoi d'un email pour information lors d'un Major Service Outage, incident majeur impactant plusieurs clients.">
                        MSO
                    </mat-header-cell>
                    <mat-cell *matCellDef="let row" [style.padding-bottom]="'24px'">
                        <mat-icon [class]="'material-icons mat-icon ' + communicationClass(row, 'MSO')"
                                  (click)="communicationChange(row, 'MSO');"
                                  [svgIcon]="communicationIcon(row, 'MSO')">
                        </mat-icon>
                    </mat-cell>
                </ng-container>

                <!-- INCIDENT -->
                <ng-container matColumnDef="incident">
                    <mat-header-cell *matHeaderCellDef
                                     mat-sort-header
                                     matTooltip="Envoi d'un email pour information lors de la déclaration d'un incident sur le projet.">
                        INCIDENT
                    </mat-header-cell>
                    <mat-cell *matCellDef="let row" [style.padding-bottom]="'24px'">
                        <mat-icon [class]="'material-icons mat-icon ' + communicationClass(row, 'INCIDENT')"
                                  (click)="communicationChange(row, 'INCIDENT');"
                                  [svgIcon]="communicationIcon(row, 'INCIDENT')">
                        </mat-icon>
                    </mat-cell>
                </ng-container>

                <!-- REQUEST -->
                <ng-container matColumnDef="request">
                    <mat-header-cell *matHeaderCellDef
                                     mat-sort-header
                                     matTooltip="Envoi d'un email pour information lors de la création d'une demande sur le projet.">
                        REQUEST
                    </mat-header-cell>
                    <mat-cell *matCellDef="let row" [style.padding-bottom]="'24px'">
                        <mat-icon [class]="'material-icons mat-icon ' + communicationClass(row, 'REQUEST')"
                                  (click)="communicationChange(row, 'REQUEST');"
                                  [svgIcon]="communicationIcon(row, 'REQUEST')">
                        </mat-icon>
                    </mat-cell>
                </ng-container>

                <!-- PATCH -->
                <ng-container matColumnDef="patch">
                    <mat-header-cell *matHeaderCellDef
                                     mat-sort-header
                                     matTooltip="Envoi d'un email pour information du patch management.">
                        PATCH
                    </mat-header-cell>
                    <mat-cell *matCellDef="let row" [style.padding-bottom]="'24px'">
                        <mat-icon [class]="'material-icons mat-icon ' + communicationClass(row, 'PATCH')"
                                  (click)="communicationChange(row, 'PATCH');"
                                  [svgIcon]="communicationIcon(row, 'PATCH')">
                        </mat-icon>
                    </mat-cell>
                </ng-container>

                <!-- CHANGE -->
                <ng-container matColumnDef="change">
                    <mat-header-cell *matHeaderCellDef
                                     mat-sort-header
                                     matTooltip="Envoi d'un email pour information lors d'une intervention planifiée.">
                        CHANGE
                    </mat-header-cell>
                    <mat-cell *matCellDef="let row" [style.padding-bottom]="'24px'">
                        <mat-icon [class]="'material-icons mat-icon ' + communicationClass(row, 'CHANGE')"
                                  (click)="communicationChange(row, 'CHANGE');"
                                  [svgIcon]="communicationIcon(row, 'CHANGE')">
                        </mat-icon>
                    </mat-cell>
                </ng-container>

                <!-- BILLING -->
                <ng-container matColumnDef="billing">
                    <mat-header-cell *matHeaderCellDef
                                     mat-sort-header
                                     matTooltip="Envoi d'un email pour information concernant la partie finance.">
                        BILLING
                    </mat-header-cell>
                    <mat-cell *matCellDef="let row" [style.padding-bottom]="'24px'">
                        <mat-icon [class]="'material-icons mat-icon ' + communicationClass(row, 'BILLING')"
                                  (click)="communicationChange(row, 'BILLING');"
                                  [svgIcon]="communicationIcon(row, 'BILLING')">
                        </mat-icon>
                    </mat-cell>
                </ng-container>

                <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
                <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>
            </mat-table>

            <mat-paginator *ngIf="showPaginator"
                           #matPaginator
                           [length]="hasProjects()"
                           [pageSizeOptions]="pageSizeOptions"
                           [pageSize]="pageSize"
                           [pageIndex]="pageIndex"></mat-paginator>

        </form>
    </div>

    <syn-message-box [hidden]="!isLimitRequest"
        leftIcon="alert-outline"
        color="warning_outlined">
        Attention, nous n’affichons que les 1000 premiers elements.
    </syn-message-box>

    <syn-message-box [hidden]="hasProjects() || !hasCompany"
                     leftIcon="information-outline"
                     color="info">
        Il n'y a pas de projet disponible pour cet utilisateur.
    </syn-message-box>

    <syn-message-box [hidden]="hasCompany"
                     leftIcon="information-outline"
                     color="info">
        Cet utilisateur n'appartient pas à une société. Il ne peut donc pas être associé à un projet.
    </syn-message-box>

</div>
